import { AlteracaoEsin204, consolidarExecutado, CrfRegistroEsin204Importacao, getAllRegistroCrfEsin204ByEsin204Id, getStatusFiltro, habilitarEdicaoCrfEsin204, salvarAlteracaoEsin204, UpdatRegistroEsin204 } from '@app/api/crf/CrtRegistroEsin204';
import { crfEsin204ViewModelResult, listCrfRegistroEsin204Importacao } from '@app/state/atom';
import { InlineEditColumnProps, Table, MasterDetailForm, Widget, FormInput, Button, ButtonSave, FormNumber, FormSwitch, useRouter, FormSelect, Form, Row, Col, FormResetButton, notification } from '@digital/ui';
import React, { useState, useEffect, useMemo } from 'react';
import { useRecoilState, useRecoilValue } from 'recoil';
import { Collapse, Icon, Tooltip } from 'antd';
import { formatCurrencyBr, formatCurrencyUS } from '@app/helpers/numbers';
import { compareBool, compareNumber, compareText, compareTypeNumber } from '@app/helpers/comparators';
import { mountFormFilterDropDown } from '@app/components/FormFilterDropDown';
import ModalErro from '@app/views/Executado/ModalErro';
import { getAllTipoExecutadoAnoMesOptions, Tipo } from '@app/api/status';
import { TipoOptions } from '@app/api/api';


interface TabelaRegistroImportacaoProps {

}

const { Panel } = Collapse;
const TabelaRegistroImportacao = (props: TabelaRegistroImportacaoProps) => {
    const [esin204From, setEsin204From] = useRecoilState(crfEsin204ViewModelResult);
    const [result, setResult] = useState<CrfRegistroEsin204Importacao[]>([])
    const [totalizador, setTotalizador] = useState({ totalValorReal: 0, totalValorDorlar: 0 });
    const [allTipoExecutadoAnoMesOptions, setAllTipoExecutadoAnoMesOptions] = useState<Tipo[]>();
    const larguraColuna = 200;


    useEffect(() => {
        let totalValorReal = 0;
        let totalValorDolar = 0;
        result.map((registro) => {
            totalValorReal += registro.importacaoValorMovto;
            totalValorDolar += registro.importacaoValorMovtoEmDolar;
        });

        setTotalizador({ totalValorReal: totalValorReal, totalValorDorlar: totalValorDolar });
    }, [result]);

    useEffect(() => {
        getAllTipoExecutadoAnoMesOptions().then((data) => {
            setAllTipoExecutadoAnoMesOptions(data)
        })
        getAllRegistroEsin()
    }, [esin204From]);

    const getAllRegistroEsin = () => {
        getAllRegistroCrfEsin204ByEsin204Id(
            esin204From.id,
            esin204From.ehContaResultado)
            .then((data) => {
                if (data)
                    setResult(data);
            });
    }

    const atualizarFornecedorMrn = (fornecedorMrnId: string, item: CrfRegistroEsin204Importacao) => {
        if (result) {
            let resultAlterado = result.filter((registro) => {
                if (registro.id === item.id) {
                    registro.fornecedorMrn = fornecedorMrnId
                    registro.telaAlteracao = true
                }
                return result
            });
            setResult(resultAlterado);
        }
    };

    const tratarValorBool = (value: boolean) => value == true ? 'SIM' : 'NÃO';

    const hasAlteracaoRegistroEsin204 = (
        record: CrfRegistroEsin204Importacao,
        alteracao: AlteracaoEsin204,
        valor: any) => {

        const novaLista = result
            .map((item) => {
                if (item.id == record.id) {
                    switch (alteracao) {
                        case AlteracaoEsin204.importacaoNumOc:
                            return { ...item, importacaoNumOc: valor, telaAlteracao: true }
                        case AlteracaoEsin204.importacaoNumContrato:
                            return { ...item, importacaoNumContrato: valor, telaAlteracao: true }
                        case AlteracaoEsin204.telaVerbaRemanescenteProvisao:
                            return { ...item, telaVerbaRemanescenteProvisao: valor, telaAlteracao: true }
                        case AlteracaoEsin204.telaDesconsiderarAno:
                            return { ...item, telaDesconsiderarAno: valor, telaAlteracao: true }
                        case AlteracaoEsin204.telaDesconsiderarAnoMotivo:
                            return { ...item, telaDesconsiderarAnoMotivo: valor, telaAlteracao: true }
                        default:
                            break;
                    }
                }
                return item;
            });

        setResult(novaLista);
    }

    const getAllColluns = (): InlineEditColumnProps<CrfRegistroEsin204Importacao>[] => {
        const coluns: InlineEditColumnProps<CrfRegistroEsin204Importacao>[] = [];

        coluns.push(
            {
                title: 'Status',
                dataIndex: 'statusProcessoConsolidarExecutado',
                width: larguraColuna,
                align: 'center',
                render(text, record, index) {
                    if (record.statusProcessoConsolidarExecutado === false) {
                        return <ModalErro messagemErro={record.mensagemProcessoConsolidarExecutado} />
                    }

                    return <Tooltip title={`${record.statusProcessamentoLinha}`}>{record.statusProcessamentoLinha} </Tooltip>;
                },
                filters: getStatusFiltro(),
                filterMultiple: true,
                onFilter: (value, record) => {
                    return record.statusProcessamentoLinha.indexOf(value) === 0
                },
                filterIcon: filtered => {
                    const classes = filtered ? 'anticon-filter ant-table-filter-selected' : '';
                    return <Icon type="filter" className={classes} style={{ minWidth: 'auto', border: 'none' }} />;
                },

            },
            {
                title: 'Conta Ctbl',
                dataIndex: 'importacaoContaCtbl',
                sorter: (a, b) => {
                    return compareText(a.importacaoContaCtbl, b.importacaoContaCtbl)
                },
                align: 'center',
                width: larguraColuna,
                ...mountFormFilterDropDown('importacaoContaCtbl', 'Pesquisar por Conta Ctbl')
            },
            {
                title: 'Descrição da conta',
                dataIndex: 'importacaoDescricaoConta',
                sorter: (a, b) => {
                    return compareText(a.importacaoDescricaoConta, b.importacaoDescricaoConta)
                },
                align: 'center',
                width: larguraColuna,
                ...mountFormFilterDropDown('importacaoDescricaoConta', 'Pesquisar por Descrição da conta')
            },
            {
                title: 'Processo',
                dataIndex: 'importacaoProcesso',
                sorter: (a, b) => {
                    return compareText(a.importacaoProcesso, b.importacaoProcesso)
                },
                align: 'center',
                width: larguraColuna,
                ...mountFormFilterDropDown('importacaoProcesso', 'Pesquisar')
            },
            {
                title: 'Referencia',
                dataIndex: 'importacaoReferencia',
                sorter: (a, b) => {
                    return compareText(a.importacaoReferencia, b.importacaoReferencia)
                },
                align: 'center',
                width: larguraColuna,
                ...mountFormFilterDropDown('importacaoReferencia', 'Pesquisar')
            },
            {
                title: 'Item e descrição',
                dataIndex: 'importacaoHistorico',
                sorter: (a, b) => {
                    return compareText(a.importacaoHistorico, b.importacaoHistorico)
                },
                align: 'center',
                width: larguraColuna,
                ...mountFormFilterDropDown('importacaoHistorico', 'Pesquisar')
            },
            {
                title: 'Data Movto',
                dataIndex: 'importacaoDataMovto',
                sorter: (a, b) => {
                    return compareText(a.importacaoDataMovto, b.importacaoDataMovto)
                },
                align: 'center',
                width: larguraColuna,
                ...mountFormFilterDropDown('importacaoDataMovto', 'Pesquisar')
            },
            {
                title: 'D/C',
                dataIndex: 'importacaoDc',
                sorter: (a, b) => {
                    return compareText(a.importacaoDc, b.importacaoDc)
                },
                align: 'center',
                width: larguraColuna,
                ...mountFormFilterDropDown('importacaoDc', 'Pesquisar')
            },
            {
                title: 'Quantidade',
                dataIndex: 'importacaoQuantidade',
                sorter: (a, b) => {
                    return compareTypeNumber(a.importacaoQuantidade, b.importacaoQuantidade)
                },
                align: 'center',
                width: larguraColuna,
                ...mountFormFilterDropDown('importacaoDc', 'Pesquisar')
            },
            {
                title: 'VLR TOTAL',
                align: 'center',
                width: larguraColuna,
                children: [{
                    title: `${formatCurrencyBr(totalizador.totalValorReal)}`,
                    align: 'center',
                    render: (text: any, record: CrfRegistroEsin204Importacao, index: number) => {
                        return [<> {formatCurrencyBr(record.importacaoValorMovto)}</>]
                    },
                    ...mountFormFilterDropDown('importacaoValorMovto', 'Pesquisar')
                }]
            },
            {
                title: 'Vl. Mat. Dolar',
                align: 'center',
                width: larguraColuna,
                children: [{
                    title: `${formatCurrencyUS(totalizador.totalValorDorlar)}`,
                    align: 'center',
                    render: (text: any, record: CrfRegistroEsin204Importacao, index: number) => {
                        return [<> {formatCurrencyUS(record.importacaoValorMovtoEmDolar)}</>]
                    },
                    ...mountFormFilterDropDown('totalValorDorlar', 'Pesquisar')
                }]

            },
            {
                title: 'Documento',
                dataIndex: 'importacaoDocumento',
                sorter: (a, b) => {
                    return compareText(a.importacaoDocumento, b.importacaoDocumento)
                },
                align: 'center',
                width: larguraColuna,
                ...mountFormFilterDropDown('importacaoDocumento', 'Pesquisar')

            },
            {
                title: 'Usuário',
                dataIndex: 'importacaoUsuario',
                sorter: (a, b) => {
                    return compareText(a.importacaoUsuario, b.importacaoUsuario)
                },
                align: 'center',
                width: larguraColuna,
                ...mountFormFilterDropDown('importacaoUsuario', 'Pesquisar')
            },
            {
                title: 'Ord manut',
                dataIndex: 'importacaoOrdManut',
                sorter: (a, b) => {
                    return compareText(a.importacaoOrdManut, b.importacaoOrdManut)
                },
                align: 'center',
                width: larguraColuna,
                ...mountFormFilterDropDown('importacaoOrdManut', 'Pesquisar')
            },
            {
                title: 'Tipo manut',
                dataIndex: 'importacaoTipoManut',
                sorter: (a, b) => {
                    return compareText(a.importacaoTipoManut, b.importacaoTipoManut)
                },
                align: 'center',
                width: larguraColuna,
                ...mountFormFilterDropDown('importacaoOrdManut', 'Pesquisar')
            },
            {
                title: 'Tipo de Tipo manut',
                dataIndex: 'importacaoTipoDeTipoManut',
                sorter: (a, b) => {
                    return compareText(a.importacaoTipoDeTipoManut, b.importacaoTipoDeTipoManut)
                },
                align: 'center',
                width: larguraColuna,
                ...mountFormFilterDropDown('importacaoTipoDeTipoManut', 'Pesquisar')
            },
            {
                title: 'Cod. eqpto',
                dataIndex: 'importacaoCodEqpto',
                sorter: (a, b) => {
                    return compareText(a.importacaoCodEqpto, b.importacaoCodEqpto)
                },
                align: 'center',
                width: larguraColuna,
                ...mountFormFilterDropDown('importacaoCodEqpto', 'Pesquisar')
            },
            {
                title: 'TAG',
                dataIndex: 'importacaoTAg',
                sorter: (a, b) => {
                    return compareText(a.importacaoTAg, b.importacaoTAg)
                },
                align: 'center',
                width: larguraColuna,
                ...mountFormFilterDropDown('importacaoTAg', 'Pesquisar')
            },
            {
                title: 'Conta origem',
                dataIndex: 'importacaoContaOrigem',
                sorter: (a, b) => {
                    return compareText(a.importacaoContaOrigem, b.importacaoContaOrigem)
                },
                align: 'center',
                width: larguraColuna,
                ...mountFormFilterDropDown('importacaoContaOrigem', 'Pesquisar')
            },
            {
                title: 'Conta despesa OP',
                dataIndex: 'importacaoContaDespesaOp',
                sorter: (a, b) => {
                    return compareText(a.importacaoContaDespesaOp, b.importacaoContaDespesaOp)
                },
                align: 'center',
                width: larguraColuna,
                ...mountFormFilterDropDown('importacaoContaDespesaOp', 'Pesquisar')
            },
            {
                title: 'FORNECEDOR',
                children: [
                    {
                        title: 'NÚMERO',
                        dataIndex: 'fornecedorNumero',
                        width: larguraColuna,
                        sorter: (a, b) => compareNumber(a ? a.fornecedorNumero : 0, b ? b.fornecedorNumero : 0),
                        ...mountFormFilterDropDown('fornecedorNumero', 'Pesquisar')
                    },
                    {
                        title: 'NOME',
                        dataIndex: 'fornecedorNome',
                        width: larguraColuna,
                        sorter: (a, b) => compareText(a.fornecedorNome, b.fornecedorNome),
                        render(text, record, index) {
                            return <>{record.fornecedorNome ? record.fornecedorNome.substring(0, 20) : ''} </>;
                        },
                        ...mountFormFilterDropDown('fornecedorNome', 'Pesquisar')
                    },
                    {
                        title: 'MRN',
                        dataIndex: 'fornecedorMrn',
                        width: larguraColuna,
                        render(text, record, index) {

                            return <>
                                <FormSelect
                                    name={`fornecedorMrn${record.id}`}
                                    placeholder="Selecione uma opção"
                                    options={allTipoExecutadoAnoMesOptions}
                                    value={record.fornecedorMrn}
                                    disabled={record.fornecedorNumero !== 0}
                                    onChange={value => {
                                        atualizarFornecedorMrn(value as string, record);
                                    }}
                                />
                            </>;
                        }
                    },
                ]
            },
            {
                title: 'Item',
                dataIndex: 'importacaoItem',
                sorter: (a, b) => {
                    return compareText(a.importacaoItem, b.importacaoItem)
                },
                align: 'center',
                width: larguraColuna,
                ...mountFormFilterDropDown('importacaoItem', 'Pesquisar')
            },
            {
                title: 'Ordem Compra',
                dataIndex: 'importacaoNumOc',
                align: 'center',
                width: larguraColuna,
                ...mountFormFilterDropDown('importacaoNumOc', 'Pesquisar'),
                render: (text: any, record: CrfRegistroEsin204Importacao, index: number) => {
                    if (esin204From.processado != true) {
                        return [
                            <FormNumber
                                name={`record${record.id}_ordemCompra`}
                                value={record.importacaoNumOc}
                                style={{ width: 70 }}
                                onChange={(e) => {
                                    hasAlteracaoRegistroEsin204(record, AlteracaoEsin204.importacaoNumOc, e);
                                }}
                            />
                        ]
                    }
                    return [<> {record.importacaoNumOc} </>]
                }
            },
            {
                title: 'Data conf. OC',
                dataIndex: 'importacaoDataConfOC',
                sorter: (a, b) => {
                    return compareText(a.importacaoDataConfOC, b.importacaoDataConfOC)
                },
                align: 'center',
                width: larguraColuna,
                ...mountFormFilterDropDown('importacaoDataConfOC', 'Pesquisar')
            },
            {
                title: 'Origem data OC',
                dataIndex: 'importacaoOrigemDataOc',
                sorter: (a, b) => {
                    return compareText(a.importacaoOrigemDataOc, b.importacaoOrigemDataOc)
                },
                align: 'center',
                width: larguraColuna,
                ...mountFormFilterDropDown('importacaoOrigemDataOc', 'Pesquisar')
            },
            {
                title: 'Requisitante OC',
                dataIndex: 'importacaoRequisitanteOc',
                sorter: (a, b) => {
                    return compareText(a.importacaoRequisitanteOc, b.importacaoRequisitanteOc)
                },
                align: 'center',
                width: larguraColuna,
                ...mountFormFilterDropDown('importacaoRequisitanteOc', 'Pesquisar')
            },
            {
                title: 'Ordem invest.',
                dataIndex: 'importacaoOrdemInvest',
                sorter: (a, b) => {
                    return compareText(a.importacaoOrdemInvest, b.importacaoOrdemInvest)
                },
                align: 'center',
                width: larguraColuna,
                ...mountFormFilterDropDown('importacaoOrdemInvest', 'Pesquisar')
            },
            {
                title: 'Divisão (Área)',
                dataIndex: 'importacaoDivisaoArea',
                sorter: (a, b) => {
                    return compareText(a.importacaoDivisaoArea, b.importacaoDivisaoArea)
                },
                align: 'center',
                width: larguraColuna,
                ...mountFormFilterDropDown('importacaoDivisaoArea', 'Pesquisar')
            },
            {
                title: 'Descrição da divisão (Área)',
                dataIndex: 'importacaoDescricaoDaDivisaoArea',
                sorter: (a, b) => {
                    return compareText(a.importacaoDescricaoDaDivisaoArea, b.importacaoDescricaoDaDivisaoArea)
                },
                align: 'center',
                width: larguraColuna,
                ...mountFormFilterDropDown('importacaoDescricaoDaDivisaoArea', 'Pesquisar')
            },
            {
                title: 'Contrato/PCs',
                dataIndex: 'importacaoNumContrato',
                sorter: (a, b) => {
                    return compareTypeNumber(a.importacaoNumContrato, b.importacaoNumContrato)
                },
                align: 'center',
                width: larguraColuna,
                ...mountFormFilterDropDown('importacaoNumContrato', 'Pesquisar'),
                render: (text: any, record: CrfRegistroEsin204Importacao, index: number) => {
                    if (esin204From.processado != true) {
                        return [
                            <FormNumber
                                name={`record${record.id}_contratoPcs`}
                                value={record.importacaoNumContrato}
                                style={{ width: 70 }}
                                onChange={(e) => {
                                    hasAlteracaoRegistroEsin204(record, AlteracaoEsin204.importacaoNumContrato, e);
                                }}
                            />
                        ]
                    }
                    return [<> {record.importacaoNumContrato} </>]
                }
            },
            {
                title: 'Num pedido',
                dataIndex: 'importacaoNumPedido',
                sorter: (a, b) => {
                    return compareText(a.importacaoNumPedido, b.importacaoNumPedido)
                },
                align: 'center',
                width: larguraColuna,
                ...mountFormFilterDropDown('importacaoNumPedido', 'Pesquisar')
            },
            {
                title: 'Observação',
                dataIndex: 'importacaoObservacao',
                sorter: (a, b) => {
                    return compareText(a.importacaoObservacao, b.importacaoObservacao)
                },
                align: 'center',
                width: larguraColuna,
                ...mountFormFilterDropDown('importacaoObservacao', 'Pesquisar')
            },
            {
                title: 'Aprop',
                dataIndex: 'importacaoTipoAprop',
                sorter: (a, b) => {
                    return compareText(a.importacaoTipoAprop, b.importacaoTipoAprop)
                },
                align: 'center',
                width: larguraColuna,
                ...mountFormFilterDropDown('importacaoTipoAprop', 'Pesquisar')
            },
            {
                title: 'VRP',
                dataIndex: 'telaVerbaRemanescenteProvisao',
                width: larguraColuna,
                align: 'center',
                ...mountFormFilterDropDown('telaVerbaRemanescenteProvisao', 'Pesquisar'),
                render(text, record, index) {
                    if (esin204From.processado != true) {
                        return [
                            <FormSwitch
                                onClick={value => {
                                    hasAlteracaoRegistroEsin204(record, AlteracaoEsin204.telaVerbaRemanescenteProvisao, value);
                                }}
                                name={`telaVerbaRemanescenteProvisao${record.id}`}
                                checked={record.telaVerbaRemanescenteProvisao}
                            />
                        ]
                    }
                    return [<> {tratarValorBool(record.telaVerbaRemanescenteProvisao)} </>]
                },

            },
            {
                title: 'DESCONSIDERAR EXECUTADO',
                dataIndex: 'telaDesconsiderarAno',
                width: larguraColuna,
                align: 'center',
                ...mountFormFilterDropDown('telaDesconsiderarAno', 'Pesquisar'),
                render(text, record, index) {
                    if (esin204From.processado != true) {
                        return [
                            <FormSwitch
                                onClick={value => {
                                    hasAlteracaoRegistroEsin204(record, AlteracaoEsin204.telaDesconsiderarAno, value);
                                }}
                                name={`telaDesconsiderarAno${record.id}`}
                                checked={record.telaDesconsiderarAno}
                            />
                        ]
                    }
                    return [<> {tratarValorBool(record.telaDesconsiderarAno)} </>]
                },

            },
            {
                title: 'MOTIVO',
                dataIndex: 'telaDesconsiderarAnoMotivo',
                width: larguraColuna,
                render(text, record, index) {
                    if (esin204From.processado != true) {
                        return <>
                            <FormInput
                                name={`telaDesconsiderarAnoMotivo${record.id}`}
                                value={record.telaDesconsiderarAnoMotivo}
                                style={{ width: 200 }}
                                onChange={(e) => {
                                    hasAlteracaoRegistroEsin204(record, AlteracaoEsin204.telaDesconsiderarAnoMotivo, e.target.value);
                                }}
                            />
                        </>;
                    }
                    return [<> {record.telaDesconsiderarAnoMotivo} </>]
                }

            }
        )
        return coluns;
    }


    const hasConsolidarExecutado = () => {

        if (esin204From && esin204From.id) {
            consolidarExecutado(esin204From.id, esin204From.ehContaResultado).then((data) => {
                if (data) {
                    window.location.reload();
                    notification.info(`A \"Rotina Atualização do Executado Mês Ano\" está em andamento, você pode acompanhar a execução na tela de rotinas.`);
                }
            });
        }
    }

    const hasSalvarAlteracao = () => {

        const itensAlterados = result.filter(c => c.telaAlteracao == true);
        if (itensAlterados) {

            const itensUpdates = itensAlterados
                .map((item) => {
                    return {
                        crfEsin204Id: item.id,
                        importacaoNumOc: item.importacaoNumOc,
                        importacaoNumContrato: item.importacaoNumContrato,
                        telaVerbaRemanescenteProvisao: item.telaVerbaRemanescenteProvisao,
                        telaDesconsiderarAno: item.telaDesconsiderarAno,
                        telaDesconsiderarAnoMotivo: item.telaDesconsiderarAnoMotivo,
                        telaFornecedorMRN: item.fornecedorMrn
                    } as UpdatRegistroEsin204
                });
            salvarAlteracaoEsin204(itensUpdates);
        }
    }

    const hasHabilitarEdicao = (crfEsin204Id: string) => {
        habilitarEdicaoCrfEsin204(crfEsin204Id).then((data) => {
            window.location.reload();
        });
    }

    const btn = () => {
        if (esin204From && esin204From.processado != true) {
            return [
                // <Button
                //     type={"link"}
                //     icon={"files-xls"}
                //     title={"EXPORTAR LINHAS DE RECLASSIFICAÇÃO"}
                //     onClick={() => {

                //     }}
                // />,

                <Button
                    type={"link"}
                    icon={"industry-gears"}
                    title={"CONSOLIDAR EXECUTADO"}
                    onClick={hasConsolidarExecutado}
                />,
                <ButtonSave
                    type="primary"
                    title={"Salvar Alterações"}
                    onClick={hasSalvarAlteracao}
                />
            ]
        } else {
            return [
                // <Button
                //     type={"link"}
                //     icon={"files-xls"}
                //     title={"EXPORTAR LINHAS DE RECLASSIFICAÇÃO"}
                //     onClick={() => {

                //     }}
                // />,
                <Button
                    type={"link"}
                    icon={"editing-edit"}
                    title={"HABILITAR EDIÇÃO"}
                    confirm={'Deseja realmente editar este registro?'}
                    onClick={() => {
                        if (esin204From) {
                            hasHabilitarEdicao(esin204From.id);
                        }
                    }}
                />,
            ]
        }

    }

    return (
        <Collapse
            bordered={false}
            defaultActiveKey={['registros']}
            expandIcon={() => <Icon type="arrows-right_4" />}>
            <Panel
                key="registros"
                header={<span>REGISTROS</span>}
                style={{ border: 0 }}>
                <MasterDetailForm>
                    <Widget actions={btn()}>
                        <Table
                            columns={getAllColluns()}
                            dataSource={result || []}
                            pagination={{ pageSize: 5 }}
                            scroll={{ x: (larguraColuna * 36) }}
                        />
                    </Widget>
                </MasterDetailForm>
            </Panel>
        </Collapse>
    )
}

export default TabelaRegistroImportacao;